import axios from "../AxiosInterCeptor/AxiosInterCeptor";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";

const URL = process.env.React_App_BaseUrl;

/**
 * Zone rates, referenced by RTO City Locations (RtoCityLocation.zoneId).
 * One zone row holds BOTH the Zone A and Zone B rate.
 */
const GetZone = () => {
    return axios
        .get(`${URL}/zone`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
                return { error: true, data: [] };
            }
            return res;
        })
        .catch((error) => {
            console.log(error);
            return { error: true, data: [] };
        });
};

const PostZone = (recData) => {
    return axios
        .post(`${URL}/zone`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
                return { error: true, message: res.message };
            }
            ToastSuccess(res.message);
            return res;
        })
        .catch((error) => {
            const message =
                error?.response?.data?.message || error.message || "Failed to save the zone";
            ToastError(message);
            return { error: true, message };
        });
};

const UpdateZone = (id, recData) => {
    return axios
        .put(`${URL}/zone/${id}`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
                return { error: true, message: res.message };
            }
            ToastSuccess(res.message);
            return res;
        })
        .catch((error) => {
            const message =
                error?.response?.data?.message || error.message || "Failed to update the zone";
            ToastError(message);
            return { error: true, message };
        });
};

const DeleteZone = (id) => {
    return axios
        .delete(`${URL}/zone/${id}`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
                return { error: true, message: res.message };
            }
            ToastSuccess(res.message);
            return res;
        })
        .catch((error) => {
            console.log(error);
            return { error: true };
        });
};

export { GetZone, PostZone, UpdateZone, DeleteZone };
